import styled, { keyframes } from 'styled-components'
import { Link } from 'react-router-dom'

const StyledIssueListItem = styled(Link)`
  user-select: none;

  .issue-image {
    position: relative;
    padding-top: 56.25%;
    border-radius: 3px;
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.gray[100]};

    .empty-icon {
      color: ${({ theme }) => theme.colors.gray[300]};
      height: 40%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 3px;
    }
  }

  .issue-details {
    margin-top: 18px;
    opacity: 1;

    .issue-title {
      letter-spacing: -0.01rem;
      line-height: 24px;
      font-weight: 600;
      font-size: 1.2rem;
      color: ${({ theme }) => theme.colors.gray[700]};
      max-width: 280px;
      display: block;
    }

    .issue-description-preview {
      margin-top: 10px;
      line-height: 22px;
      color: ${({ theme }) => theme.colors.gray[600]};
      display: -webkit-box;
      -webkit-line-clamp: 4;
      overflow: hidden;
      -webkit-box-orient: vertical;
    }
  }
`

export default StyledIssueListItem
